import { addCollect, cancelCollect } from '@/api';
import { useSceneOps } from '@/features/createWork';
import { useI18n } from 'vue-i18n';
import { MockSceneDetails } from '~/api/interface/scene';
import { COLLECTION_MAP, COLLECTION_SOURCE, RESOURCE_TYPE } from '~/utils/constant';

export function useScene() {
  const { t: $t } = useI18n();
  const userInfo = useUserInfo();
  function handleUse(id: number) {
    const { createOps } = useSceneOps();
    createOps('create', {
      id,
      is_custom_config: false,
    });
  }

  function handleLike(data: typeof MockSceneDetails) {
    // const path = `${window.location.origin}/workspace/scene?id=${id}&is_star_person=${is_star_person}`;
    if (userInfo.value) {
      if (!data.is_star_personal) {
        addCollect({
          model_id: data.id,
          model_type: COLLECTION_MAP.SOURCE,
          resource_type: RESOURCE_TYPE.STUDIO,
          source: COLLECTION_SOURCE.YOUYAN,
        });
        message.success($t('shou-cang-cheng-gong'));
      } else {
        cancelCollect({
          model_ids: [data.id],
          model_type: COLLECTION_MAP.SOURCE,
          resource_type: RESOURCE_TYPE.STUDIO,
        });
        message.success($t('qu-xiao-shou-cang-cheng-gong'));
      }

      data.is_star_personal = !data.is_star_personal;
      // navigateTo(path, { external: true });
    } else {
      navigateTo(`/login?redirect=${encodeURIComponent(encodeURIComponent(location.href))}`, {
        external: true,
      });
    }
  }

  return {
    handleUse,
    handleLike,
  };
}
